<template>
  <div class="electricity">
    <div class="electricity-container" id="blips">
      <!-- blips get added here -->
    </div>
    <div class="row" v-if="dev">
      <button @click="startRecording">Start Recording</button>
      <button @click="stopRecording">Stop Recording</button>
      <div class="spacer"></div>
      <button @click="playback">Play Back</button>
      <button @click="saveRecording">Save Recording</button>
    </div>
    <p v-if="dev && isRecording">Recording</p>
  </div>
</template>
<script>
import { Howl } from "howler";
import { mapState } from "vuex";

export default {
  name: "SoundsTrain",
  props: {},
  computed: {
    ...mapState(["transitioning", "transitioningBack"]),
  },
  data() {
    return {
      dev: false,
      isRecording: false,
      sounds: {
        blip1: "/sounds/blip-01.wav",
      },
      sound: null,
      soundBack: null,
      // events: [],
      events: [
        { keyCode: 65, time: 50 },
        { keyCode: 83, time: 125 },
        { keyCode: 68, time: 175 },
      ],
      // events: [
      //   { keyCode: 65, time: 50 },
      //   { keyCode: 83, time: 100 },
      //   { keyCode: 68, time: 150 },
      //   { keyCode: 70, time: 275 },
      //   { keyCode: 70, time: 290 },
      // ],
      eventsBack: [
        { keyCode: 65, time: 20 },
        { keyCode: 83, time: 75 },
      ],
      startTime: null,
      isAnimating: false,
    };
  },
  methods: {
    createAndAnimateCircle() {
      // Create a new div element
      const blipEl = document.createElement("div");

      // Give it an id
      // circle.id = "circle";
      blipEl.classList.add("blip");
      blipEl.innerHTML = `
        <div class="blip-inner"></div>
        <div class="blip-outer"></div>
      `;

      // Find the container element
      const container = document.getElementById("blips");

      // Append the new element to the container
      container.appendChild(blipEl);

      // After 10 ms, add the "animate" class
      setTimeout(() => {
        blipEl.classList.add("animate");
      }, 10);
    },

    startRecording() {
      this.isRecording = true;
      this.startTime = Date.now();
      window.addEventListener("keydown", this.recordEvent);
    },
    stopRecording() {
      this.isRecording = false;
      window.removeEventListener("keydown", this.recordEvent);
    },
    recordEvent(event) {
      if (this.isRecording) {
        this.events.push({
          keyCode: event.keyCode,
          time: Date.now() - this.startTime,
        });
        this.sound.play();
      }
    },
    playback() {
      // Just play one sound
      this.sound.play();

      this.events.forEach((event, i) => {
        setTimeout(() => {
          this.createAndAnimateCircle();

          setTimeout(() => {
            this.isAnimating = false;
          }, 100);
        }, event.time);
      });
    },
    playbackBack() {
      // Just play one sound
      setTimeout(() => {
        this.sound.play();
      }, 0);

      this.eventsBack.forEach((event, i) => {
        setTimeout(() => {
          this.createAndAnimateCircle();

          setTimeout(() => {
            this.isAnimating = false;
          }, 100); // change the duration to match the length of your sound
        }, event.time);
      });
    },
    saveRecording() {
      const data = new Blob([JSON.stringify(this.events)], {
        type: "application/json",
      });
      const url = window.URL.createObjectURL(data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "recording.json");
      document.body.appendChild(link);
      link.click();
    },
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (this.isRecording) {
        this.saveKey(e);
      }
    });

    console.log("loading electricity");

    this.soundBack = new Howl({
      src: ["/sounds/blip-01.wav"],
      html5: true,
      preload: true,
    });
    this.sound = new Howl({
      src: ["/sounds/train-blip-02.mp3"],
      html5: true,
      preload: true,
    });
  },
  watch: {
    "$store.state.transitioning"(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.playback();
        }, 200);
      }
    },
    "$store.state.transitioningBack"(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.playbackBack();
        }, 200);
      }
    },
  },
};
</script>

<style>
.electricity,
.electricity-container {
  width: 100%;
  height: 200px;
  overflow: hidden;
  display: flex;
}

.blip {
  position: absolute;
  width: 4rem;
  height: 4rem;
  left: 0;
  top: 42%;
  border-radius: 50%;
  transition: all 550ms cubic-bezier(0.18, 0.3, 0.39, 0.5);
  transform: translateX(calc(100vw + 12rem));
}

.blip-inner {
  position: absolute;
  background-color: white;
  filter: blur(12px);
  height: 100%;
  width: 100%;
  border-radius: 50%;
}

.blip-outer {
  position: absolute;
  background: #2097ED;
  filter: blur(30px);
  height: 100%;
  width: 100%;
  border-radius: 50%;
  opacity: 0.6;
}

.blip.animate {
  transform: translateX(calc(0vw - 12rem));
}

@keyframes grow {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1);
  }
}

.row {
  display: flex;
  direction: row;
}

.spacer {
  width: 40px;
}

@media screen and (max-width: 600px) {
  .blip {
    width: 3rem;
    height: 3rem;
  }

  .blip-inner {
    filter: blur(8px);
  }

  .blip-outer {
    filter: blur(24px);
  }
}
</style>
